import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _create_class from "@swc/helpers/src/_create_class.mjs";
import _get from "@swc/helpers/src/_get.mjs";
import _get_prototype_of from "@swc/helpers/src/_get_prototype_of.mjs";
import _inherits from "@swc/helpers/src/_inherits.mjs";
import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _create_super from "@swc/helpers/src/_create_super.mjs";
import { Token } from "../token";
import { TokenAmount } from "./tokenAmount";
import { currencyEquals } from "../token";
import invariant from "tiny-invariant";
import JSBI from "jsbi";
import { TEN } from "../../constants";
import { Fraction } from "./fraction";
import { CurrencyAmount } from "./currencyAmount";
export var Price = /*#__PURE__*/ function(Fraction1) {
    "use strict";
    _inherits(Price, Fraction1);
    var _super = _create_super(Price);
    function Price(baseCurrency, quoteCurrency, denominator, numerator) {
        _class_call_check(this, Price);
        var _this;
        _this = _super.call(this, numerator, denominator);
        _this.baseCurrency = baseCurrency;
        _this.quoteCurrency = quoteCurrency;
        _this.scalar = new Fraction(JSBI.exponentiate(TEN, JSBI.BigInt(baseCurrency.decimals)), JSBI.exponentiate(TEN, JSBI.BigInt(quoteCurrency.decimals)));
        return _this;
    }
    var _proto = Price.prototype;
    _proto.invert = function invert() {
        return new Price(this.quoteCurrency, this.baseCurrency, this.numerator, this.denominator);
    };
    _proto.multiply = function multiply(other) {
        invariant(currencyEquals(this.quoteCurrency, other.baseCurrency), "TOKEN");
        var fraction = _get(_get_prototype_of(Price.prototype), "multiply", this).call(this, other);
        return new Price(this.baseCurrency, other.quoteCurrency, fraction.denominator, fraction.numerator);
    };
    // performs floor division on overflow
    _proto.quote = function quote(currencyAmount) {
        invariant(currencyEquals(currencyAmount.currency, this.baseCurrency), "TOKEN");
        if (_instanceof(this.quoteCurrency, Token)) {
            return new TokenAmount(this.quoteCurrency, _get(_get_prototype_of(Price.prototype), "multiply", this).call(this, currencyAmount.raw).quotient);
        }
        return CurrencyAmount.ether(_get(_get_prototype_of(Price.prototype), "multiply", this).call(this, currencyAmount.raw).quotient);
    };
    _proto.toSignificant = function toSignificant() {
        var significantDigits = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 6, format = arguments.length > 1 ? arguments[1] : void 0, rounding = arguments.length > 2 ? arguments[2] : void 0;
        return this.adjusted.toSignificant(significantDigits, format, rounding);
    };
    _proto.toFixed = function toFixed() {
        var decimalPlaces = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 4, format = arguments.length > 1 ? arguments[1] : void 0, rounding = arguments.length > 2 ? arguments[2] : void 0;
        return this.adjusted.toFixed(decimalPlaces, format, rounding);
    };
    Price.fromRoute = function fromRoute(route) {
        var prices = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = route.pairs.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = _sliced_to_array(_step.value, 2), i = _value[0], pair = _value[1];
                prices.push(route.path[i].equals(pair.token0) ? new Price(pair.reserve0.currency, pair.reserve1.currency, pair.reserve0.raw, pair.reserve1.raw) : new Price(pair.reserve1.currency, pair.reserve0.currency, pair.reserve1.raw, pair.reserve0.raw));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return prices.slice(1).reduce(function(accumulator, currentValue) {
            return accumulator.multiply(currentValue);
        }, prices[0]);
    };
    _create_class(Price, [
        {
            key: "raw",
            get: function get() {
                return new Fraction(this.numerator, this.denominator);
            }
        },
        {
            key: "adjusted",
            get: function get() {
                return _get(_get_prototype_of(Price.prototype), "multiply", this).call(this, this.scalar);
            }
        }
    ]);
    return Price;
}(Fraction);
